var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3766 13.5202C23.7773 12.8621 27.7235 12.3916 32 12.1614V1.33375C32 0.598061 31.4019 0 30.6662 0H1.33375C0.598061 0 0 0.598061 0 1.33375V20.0013C0 26.6275 5.37254 32 11.9987 32H30.6662C31.4019 32 32 31.4019 32 30.6663V27.8386C27.7235 27.6084 23.7773 27.1354 20.3766 26.4798C12.8746 25.021 8 22.6612 8 19.9987C8 17.3363 12.8746 14.9765 20.3766 13.5177V13.5202Z",
    fill: "#CC2630"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebar_logo.cbba88a777ed7e74339fb5161415941d.svg";
export { ForwardRef as ReactComponent };